import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import cuid from 'cuid';
import { calculateRem } from '@uie/javascript-style-helpers';
import { breakpoints } from '@vzrf/react-theme-helpers';

const propTypes = {
  selectedCallback: PropTypes.func.isRequired,
  filterChipStyles: PropTypes.object,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  isSelected: PropTypes.string
};

const defaultProps = {
  filterChipStyles: undefined,
  id: false,
  title: 'Filter',
  isSelected: 'false'
};

const FilterChipWrapper = styled.div`
  background-color: ${({ theme }) => theme.white};
  font-weight: normal;
  line-height: ${calculateRem(20)};
  position: relative;
  display: inline-block;
  margin:3px;
  ${props => props.id !== 'search'} { 
    top:-2px;
  }
  ${props => props.className === 'inactive'} { 
    border-bottom:4px solid #d52b1e;
  }
`;

const FilterButton = styled.button`
  text-transform: capitalize;
  background-color: transparent;
  border: 0;
  color: #b4b4b4;
  display: inline-block;
  font-size: ${calculateRem(16)};
  height: ${calculateRem(58)};
  line-height: ${calculateRem(58)};
  margin: 0;
  overflow: visible;
  padding: ${calculateRem(0, 10, 0, 10)};
  width: 100%;
  min-width: ${calculateRem(72)};
  font-weight:bold;
  outline: 0;
  &:hover {
    cursor: pointer;
  }
  ${props => props.className === 'inactive'} {
    color: #0f0f0f;
  }
  @media only screen and (min-width: ${breakpoints.md}) {
    padding: ${calculateRem(0, 20, 0, 20)};
  };

  & svg {
    position: relative;
    top: 6px;
  }
`;

const handleKeyDown = (selectedCallback, id, e) => {
  let parent = e.target.parentNode;
  let grandParent = parent.parentNode; 
  if (e.keyCode === 13 || e.keyCode === 32) {
    selectedChip(selectedCallback, id, e);
  }
  else if (e.keyCode === 35) {
    document.querySelector("#all").getElementsByTagName("button")[0].focus();
    return;
  }else if (e.keyCode === 36) {
    grandParent.style.left ="0px";
    document.querySelector("#search").getElementsByTagName("button")[0].focus()
    return;
  }
  if (e.keyCode === 39 || e.keyCode === 37 || e.keyCode === 35 ||  e.keyCode ===36) {
    if (id !== 'search') {
      if (e.keyCode === 39) {
        let nextsibling = parent.nextElementSibling;
        let previousSibling = parent.nextElementSibling;
        let offsetVal = 0;
        while(previousSibling !== null){
          offsetVal = offsetVal + previousSibling.clientWidth
          previousSibling = previousSibling.previousElementSibling 
        }        
        if (nextsibling) {
          let newVar = offsetVal - nextsibling.clientWidth;
          grandParent.style.left ="-" +  newVar + "px";
          nextsibling.getElementsByTagName("button")[0].focus();
        } else {
          grandParent.style.left ="0px";
          document.querySelector("#search").getElementsByTagName("button")[0].focus()
        }
      }
      else if (e.keyCode === 37) {
        let prevsibling = parent.previousElementSibling;
        let previousSibling = parent.previousElementSibling;
        let offsetVal = 0;
        while(previousSibling !== null){
          offsetVal = offsetVal + previousSibling.clientWidth
          previousSibling = previousSibling.previousElementSibling 
        } 
        if (prevsibling) {
          let newVar = offsetVal - prevsibling?.clientWidth;
          grandParent.style.left ="-" +  newVar + "px";
          prevsibling.getElementsByTagName("button")[0].focus();
        } else {
          grandParent.style.left ="0px";
          document.querySelector("#search").getElementsByTagName("button")[0].focus()
        }
      }
    }
    else if (id === 'search' && e.keyCode === 39) {
      let parent = document.getElementById('search').parentNode;
      let nextsibling = parent.nextElementSibling;
      if (nextsibling) {
        grandParent.style.left ="0px";
        document.querySelector("#popular").getElementsByTagName("button")[0].focus();
      }

    }
    else if (id === 'search' && e.keyCode === 37) {
      document.querySelector("#all").getElementsByTagName("button")[0].focus()

    }
  }
}

const selectedChip = (selectedCallback, id, event) => {
  selectedCallback(id, event);
  if(id==="search"){
    var tempElem = document.getElementById("channelContainer");
    const tempChild = tempElem?.querySelector("#search");
    tempChild?.focus()
  }
};

const  focusNextElement = ()=> {
  setTimeout(()=>{
    var channelContainer = document.getElementById("channelContainer");
    var checkboxes = channelContainer.querySelectorAll('[role="checkbox"][tabIndex="0"]');
    checkboxes[0] ?.focus()
  },0)
}
const FilterChip = ({
  id,
  selectedCallback,
  filterChipStyles,
  title,
  isSelected
}) => (
  <FilterChipWrapper
    id={id ? id : cuid(6).substr(-6)}
    style={filterChipStyles}
    className={isSelected === 'true' ? 'active' : 'inactive'}
  >
    <FilterButton tabIndex={ isSelected==='true'?'0':'-1'} className={isSelected === 'true' ? 'active' : 'inactive'} role='tab' id={isSelected==='true'?'chanelCategoryItem':''} aria-controls='channelContainer' aria-selected={isSelected ==='true' ? 'true':'false'} aria-label={id ==='search'? 'search':  title}
    onKeyDown={e => {
      handleKeyDown(selectedCallback, id, e)
        if(e.keyCode===13){
          focusNextElement()
        }
    }}
     onClick={e => selectedChip(selectedCallback, id, e)}>{title}</FilterButton>
  </FilterChipWrapper>
);

FilterChip.defaultProps = defaultProps;
FilterChip.propTypes = propTypes;

export default FilterChip;
